import { ExternalUser } from '../../models';
import { CreateExternalUserRequest } from '../../../../web-api-client';

export const mapExternalUserToCreateRequest = (
  user: ExternalUser
): CreateExternalUserRequest => {
  return new CreateExternalUserRequest({
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    organization: user.organization,
    territory: user.territory,
    isActive: user.isActive,
  });
};
